import { render, staticRenderFns } from "./AddView.vue?vue&type=template&id=9c515b52&scoped=true&"
import script from "./AddView.vue?vue&type=script&lang=js&"
export * from "./AddView.vue?vue&type=script&lang=js&"
import style0 from "./AddView.vue?vue&type=style&index=0&id=9c515b52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c515b52",
  null
  
)

export default component.exports